/* EzyClean theme JS — no dependencies */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    var fmt = (window.Ezy && Ezy.moneyFormat) || '${{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    function withDelims(n, prec, thou, dec) {
      thou = thou || ','; dec = dec || '.';
      var num = (n / 100).toFixed(prec);
      var parts = num.split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thou);
      return parts[1] ? parts[0] + dec + parts[1] : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(cents, 0);
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        default: return withDelims(cents, 2);
      }
    });
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  /* ---------- Drawers ---------- */
  var lastFocus = null;
  function openDrawer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');
    var f = el.querySelector('[data-autofocus]') || el.querySelector('button, a');
    setTimeout(function () { f && f.focus(); }, 60);
  }
  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.documentElement.classList.remove('no-scroll');
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open-drawer]');
    if (opener) {
      var target = document.getElementById(opener.getAttribute('data-open-drawer'));
      if (target) {
        e.preventDefault();
        opener.setAttribute('aria-expanded', 'true');
        if (target.id === 'CartDrawer') refreshCart().then(function () { openDrawer(target); });
        else openDrawer(target);
      }
      return;
    }
    var closer = e.target.closest('[data-close-drawer]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { var d = $('.drawer.is-open'); if (d) closeDrawer(d); }
  });

  /* ---------- Header ---------- */
  var header = $('.site-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- Cart ---------- */
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count; el.hidden = !count;
    });
  }
  function linePrice(item) {
    var orig = item.original_line_price, fin = item.final_line_price;
    if (fin === 0 && orig > 0) return '<span class="line__price"><s class="line__was">' + formatMoney(orig) + '</s> <span class="line__free">FREE</span></span>';
    if (orig > fin) return '<span class="line__price"><s class="line__was">' + formatMoney(orig) + '</s> ' + formatMoney(fin) + '</span>';
    return '<span class="line__price">' + formatMoney(fin) + '</span>';
  }
  function renderCart(cart) {
    var drawer = $('#CartDrawer');
    updateCount(cart.item_count);
    if (!drawer) return cart;
    var body = $('[data-cart-body]', drawer);
    var foot = $('[data-cart-foot]', drawer);
    if (!cart.item_count) {
      body.innerHTML = $('#CartEmptyTpl').innerHTML;
      foot.hidden = true;
      return cart;
    }
    foot.hidden = false;
    body.innerHTML = cart.items.map(function (item, i) {
      var img = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
      var variant = item.variant_title && item.product_has_only_default_variant === false ? '<div class="line__variant">' + esc(item.variant_title) + '</div>' : '';
      var deals = (item.line_level_discount_allocations || []).map(function (a) { return a.discount_application && a.discount_application.title; }).filter(Boolean);
      if (deals.length) variant += '<div class="line__deal">' + esc(deals[0]) + '</div>';
      return '<div class="line" data-line="' + (i + 1) + '">' +
        '<a class="line__img" href="' + esc(item.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(item.product_title) + '" width="84" height="84" loading="lazy">' : '') + '</a>' +
        '<div><a class="line__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' + variant +
        '<div class="line__row"><div class="qty qty--sm">' +
        '<button type="button" data-line-change="' + (i + 1) + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M5 12h14"/></svg></button>' +
        '<input type="number" value="' + item.quantity + '" min="0" aria-label="Quantity" readonly>' +
        '<button type="button" data-line-change="' + (i + 1) + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 5v14M5 12h14"/></svg></button>' +
        '</div>' + linePrice(item) + '</div>' +
        '<button type="button" class="line__remove" data-line-change="' + (i + 1) + '" data-qty="0">Remove</button>' +
        '</div></div>';
    }).join('');
    $('[data-cart-subtotal]', drawer).textContent = formatMoney(cart.total_price);
    return cart;
  }
  function refreshCart() {
    return fetch(Ezy.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-change]');
    if (!b) return;
    e.preventDefault();
    var body = b.closest('[data-cart-body]'); if (body) body.style.opacity = '.5';
    fetch(Ezy.routes.cart_change + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(b.getAttribute('data-line-change'), 10), quantity: Math.max(0, parseInt(b.getAttribute('data-qty'), 10)) })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      if (body) body.style.opacity = '';
      if (document.body.classList.contains('tpl-cart')) { window.location.reload(); return; }
      renderCart(cart);
    }).catch(function () { if (body) body.style.opacity = ''; });
  });

  /* ---------- Product form ---------- */
  $$('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var msg = form.querySelector('[data-form-msg]');
      if (msg) msg.hidden = true;
      btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');
      fetch(Ezy.routes.cart_add + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy');
          if (!res.ok) { if (msg) { msg.textContent = res.j.description || res.j.message || 'Something went wrong. Please try again.'; msg.hidden = false; } return; }
          return refreshCart().then(function () { openDrawer($('#CartDrawer')); });
        })
        .catch(function () { btn.classList.remove('is-loading'); form.submit(); });
    });
  });

  /* Quantity steppers on product page */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var v = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10);
    input.value = Math.max(1, Math.min(99, v));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Variant selection */
  $$('[data-product-json]').forEach(function (script) {
    var product; try { product = JSON.parse(script.textContent); } catch (err) { return; }
    var root = script.closest('[data-product]');
    if (!root) return;
    root.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option-index]')) return;
      var selected = $$('[data-option-index]:checked', root).map(function (i) { return i.value; });
      var variant = product.variants.find(function (v) { return v.options.every(function (o, idx) { return o === selected[idx]; }); });
      $$('[data-option-value-label]', root).forEach(function (el, idx) { el.textContent = selected[idx] || ''; });
      var idInput = $('input[name="id"]', root);
      var btns = $$('[data-atc]');
      var priceEls = $$('[data-price]');
      if (!variant) { btns.forEach(function (b) { b.disabled = true; b.querySelector('span').textContent = 'Unavailable'; }); return; }
      idInput.value = variant.id;
      priceEls.forEach(function (p) { p.textContent = formatMoney(variant.price); });
      btns.forEach(function (b) { b.disabled = !variant.available; b.querySelector('span').textContent = variant.available ? 'Add to cart' : 'Sold out'; });
      if (variant.featured_media) goToMedia(root, variant.featured_media.id);
      var url = new URL(window.location.href); url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    });
  });

  /* ---------- Gallery ---------- */
  function goToMedia(root, mediaId) {
    var slide = $('[data-media-id="' + mediaId + '"]', root);
    if (slide) slide.parentElement.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
  }
  $$('[data-gallery]').forEach(function (g) {
    var track = $('.gallery__track', g);
    var slides = $$('.gallery__slide', g);
    var thumbs = $$('.gallery__thumb', g);
    var dots = $$('.gallery__dots span', g);
    if (!track) return;
    var setActive = function (i) {
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    };
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () { setActive(Math.round(track.scrollLeft / track.clientWidth)); }, 60);
    }, { passive: true });
    thumbs.forEach(function (th, i) {
      th.addEventListener('click', function () { track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' }); setActive(i); });
    });
  });

  /* ---------- Sticky add to cart ---------- */
  var sticky = $('[data-sticky-atc]');
  var mainAtc = $('[data-main-atc]');
  if (sticky && mainAtc && 'IntersectionObserver' in window) {
    var footer = $('.site-footer');
    var mainVisible = true, footerVisible = false;
    var upd = function () {
      var show = !mainVisible && !footerVisible && mainAtc.getBoundingClientRect().top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      $$('button, a', sticky).forEach(function (el) { el.tabIndex = show ? 0 : -1; });
    };
    new IntersectionObserver(function (en) { mainVisible = en[0].isIntersecting; upd(); }).observe(mainAtc);
    if (footer) new IntersectionObserver(function (en) { footerVisible = en[0].isIntersecting; upd(); }).observe(footer);
    upd();
    var sbtn = $('[data-sticky-submit]', sticky);
    if (sbtn) sbtn.addEventListener('click', function () {
      var f = $('form[data-product-form]');
      if (f) { if (f.requestSubmit) f.requestSubmit(); else f.dispatchEvent(new Event('submit', { cancelable: true })); }
    });
  }

  /* ---------- Reveal on scroll ---------- */
  var reveals = $$('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach(function (el) { io.observe(el); });
  } else { reveals.forEach(function (el) { el.classList.add('is-in'); }); }

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function () { $$('.reveal').forEach(function (el) { el.classList.add('is-in'); }); });
})();
